import { UserDefinedTableConfig } from './user-defined-object.types';

export class SetUserDefinedTableData {
  static readonly type = '[UserDefinedObject] Set User Defined Object Table Data';
  constructor(public udTableData: any) // public entityID: number = null,
  // public contractID: number = null,
  // public claimID: number = null
  {}
}

export class ResetState {
  static readonly type = '[UserDefinedObject] Reset State';
  constructor() {}
}

export class UpdateUserDefinedData {
  static readonly type = '[UserDefinedObject] Update User Defined Data';
  constructor(public udRecord: any) {}
}

export class AddUserDefinedData {
  static readonly type = '[UserDefinedObject] Add User Defined Data';
  constructor(public udObjectCode: string) {}
}

export class CloneUserDefinedData {
  static readonly type = '[UserDefinedObject] Clone User Defined Data';
  constructor(public udRecord: any, public copies: number = 1) {}
}

export class DeleteUserDefinedData {
  static readonly type = '[UserDefinedObject] Delete User Defined Data';
  constructor(public udRecord: any) {}
}

export class RestoreUserDefinedData {
  static readonly type = '[UserDefinedObject] Restore User Defined Data';
  constructor(public udRecord: any) {}
}

//Adds or updates config for supplied table to state
export class SetUserDefinedTableConfig {
  static readonly type = '[UserDefinedObject] Set USer Defined Table Config';
  constructor(public udTableConfig: UserDefinedTableConfig) {}
}
